(function() {
    'use strict';

    angular.module('product')
        .controller('ProductOptionGroupDetailController', ProductOptionGroupDetailController);

    ProductOptionGroupDetailController.$inject = ['$state', 'notificationSrvc', 'productOptionGroupDataSrvc', 'productOptionDataSrvc', 'productOptionSrvc', 'productOptionMessagesConst', 'lodashService', 'productOptionPermissionsConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc', 'searchFilterSrvc'];

    function ProductOptionGroupDetailController($state, notificationSrvc, productOptionGroupDataSrvc, productOptionDataSrvc, productOptionSrvc, productOptionMessagesConst, lodashService, productOptionPermissionsConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc, searchFilterSrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.optionsRows = [];
        self.optionsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'label',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis wewnętrzny',
            value: 'internal_description',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Dni realizacji',
            value: 'realization_days',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Linia technologiczna',
            value: 'tech_line',
            type: 'boolean',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = productOptionPermissionsConst;
        self.searchQuery = {
            pk: null,
            label: null,
            internal_description: null,
            realization_days: null,
            tech_line: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getOptions();
            getGroupName($state.params.pk);
        }

        function getOptions(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    group_pk: $state.params.pk,
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    label: self.searchQuery.label,
                    internal_description: self.searchQuery.internal_description,
                    realization_days: self.searchQuery.realization_days,
                    tech_line: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.tech_line),
                    ordering: self.searchQuery.ordering
                };
            }

            return productOptionDataSrvc.optionsList(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.optionsRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getOptions);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function getGroupName(pk) {
            return productOptionGroupDataSrvc.get({
                pk: pk
            }).$promise.then(function(response) {
                self.groupName = response.name_pl;
                return response;
            });
        }

        function onCreate() {
            $state.go('layout.productOption.create', { pk: $state.params.pk });
        }

        function onEdit(row) {
            $state.go('layout.productOption.update', { pk: row.pk });
        }

        function onDelete(row) {
            return productOptionSrvc.remove(row.label, row.pk, function(response) {
                notificationSrvc.notification("success", productOptionMessagesConst.delete);
                lodashService.remove(self.optionsRows, { pk: row.pk });
                return response;
            }, function(response) {
                notificationSrvc.notification("error", response.data.data.non_field_errors[0]);
            });
        }

        function onReorder(row, newPos) {
            return productOptionDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getOptions();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getOptions();
        }
    }
})();
